import { render, staticRenderFns } from "./GLBudget.vue?vue&type=template&id=7945dfaa&"
import script from "./GLBudget.vue?vue&type=script&lang=js&"
export * from "./GLBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports